import styled from 'styled-components';

export const StyledCard = styled.div`
  height: 100%;
  max-height: 223px;

  ${'' /* 날씨 메인 카드*/}
  .weather-main {
    &-wrapper {
      padding: 17px 34px 0px 34px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      //min-height: 235px;
      justify-content: space-between;
      align-items: flex-end;
      height: 100%;
      //max-height: 21vh;

      .mini {
        //height: 21.5vh;
      }
      img {
        width: 150px;
        height: 150px;
      }
    }

    &-header-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  ${'' /* 날씨 깃발 카드*/}
  .weather-flag {
    &-wrapper {
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 0px 6px 0px #00000026;

      &.sm {
        padding: 12px 12px 12px 30px;
        justify-content: center;
        align-items: center;
        height: 100%;

        .weather-flag-header-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .weather-flag-content-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          font-family: Poppins, sans-serif;

          &.MuiContainer-root {
            height: 100% !important;
          }

          .MuiContainer-root {
            height: 100% !important;
          }

          .content-img {
            width: 100px;
            height: 100px;
            margin-right: 15px;
            margin-bottom: 10px;
          }

          .content {
            display: flex;
            flex-direction: column;
            text-align: left;
            font-family: Poppins, sans-serif;

            .work-limit-title {
              font-size: 15px;
              font-weight: 600;
              margin-bottom: 5px;
            }
          }
        }
      }

      &.md,
      &.lg {
        height: 184px;
        padding: 0px 12px 12px 28px;
        justify-content: center;
        align-items: flex-end;

        .weather-flag-wrapper-button {
          margin-bottom: 14px;

          .MuiButton-colorPrimary,
          .weather-flag-wrapper-button-empty {
            height: 30px;
          }
        }

        .weather-flag-header-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .weather-flag-content-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          font-family: Poppins, sans-serif;

          .content-img {
            width: 75px;
            height: 85px;
            margin-right: 10px;
            margin-bottom: 10px;
          }

          .content {
            display: flex;
            flex-direction: column;
            text-align: left;
            font-family: Poppins, sans-serif;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;

            .work-limit-title {
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              line-height: 24px;
            }
          }
        }
      }
    }
  }

  ${'' /* 날씨 서브 카드*/}
  .weather-sub {
    &-wrapper {
      padding-top: 18px;
      padding-left: 18px;

      display: flex;
      flex-direction: column;
      height: 184px;
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 0px 0px 6px 0px #00000026;
      justify-content: space-between;

      &-content-wrapper {
        padding-left: 18px;
        padding-right: 20px;
        padding-bottom: 16px;

        &-title {
          height: 24px;
          margin-bottom: 6px;

          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          text-align: right;
        }

        &-content {
          height: 42px;
          font-family: Poppins;
          font-size: 28px;
          font-weight: 500;
          line-height: 42px;
          text-align: right;
          color: #585959;
        }
      }

      .icon {
        width: 40px;
        height: 40px;
      }
    }
  }
  ${'' /* List Card */}
  .list-card-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px 21px;
    list-style-type: none;
    border-radius: 10px;
    max-height: ${(props) => props.maxHeight};

    &-title {
      color: #2f2f35;
      font-family: Poppins, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 12px;
    }

    /* 리스트 전체 조회 되어 스크롤 설정 */
    &-title + ul {
      overflow-y: scroll;
      height: 100%;

      &::-webkit-scrollbar {
        width: 6px;
        height: 0;
        border-radius: 6px;
      }
    }

    li::before {
      content: '*';
      color: #2f2f35;
      font-family: Poppins, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-right: 5px;
    }

    &-item {
      position: relative;
      color: #2f2f35;
      font-family: Poppins, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin: 5px 0px;
      overflow: hidden;
      white-space: nowrap;

      /* 조회 리스트 제목 ... 처리 */
      span.title {
        position: unset;
        width: 18rem;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0;
      }
    }
  }

  ${'' /* status Card */}
  .status-card-wrapper {
    //height: 21.5vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px 21px;
    list-style-type: none;
    border-radius: 10px;
    //max-height: ${(props) => props.maxHeight};
    max-height: 21vh;

    &-title {
      color: #2f2f35;
      font-family: Poppins, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 12px;
    }

    &-content {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 100%;
      align-items: center;
      //margin: 14px 0;

      .name {
        width: 68px;
        margin-right: 10px;
        color: #2f2f35;
        font-family: Poppins, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .strValue {
        width: 20px;
        margin-left: 12px;
        color: #2f2f35;
        text-align: right;
        font-family: Poppins, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }
`;
